import React, { useEffect, useState } from "react";
import io from "socket.io-client";
import { Container, Typography, Snackbar } from "@mui/material";

const socket = io("http://localhost:5002");

const NotificationComponent = () => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    socket.on("notification", (data) => {
      setMessage(data);
      setOpen(true);
    });

    return () => socket.off("notification");
  }, []);

  return (
    <Container>
      <Typography variant="h5">Real-Time Notifications</Typography>
      <Snackbar open={open} autoHideDuration={4000} message={message} onClose={() => setOpen(false)} />
    </Container>
  );
};

export default NotificationComponent;
